// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"38":"f5bce8a57be249a7","440":"d2068fa8535060d0","581":"551a5e3182a94102"}[chunkId] + ".js";
};